export const environment = {
  production: false,
  url_api: 'https://svrd.api.tictacsante.com/rest',
  url_api1: 'http://localhost:30184/rest',
};
